import { TimelineItemContentBadgeTypeT } from 'components/Timeline/types'
import { getAvatarFromPerson } from 'pages/Tasks/utils/timeline'
import { TIMELINE_STATUS } from 'redesign/components/organisms/timeline-item/constants'
import { formatDate } from 'redesign/shared/date'
import { DATE_FORMAT_VARIANTS } from 'redesign/shared/date/constants'
import type { DocumentT, PersonT } from 'types'
import { createTimeLineItem, createTimelineItemAttributesWithHrAvatar } from '../timeline-item-factory'
import type { MayAddItemProps } from '../types'
import { getAbsenceDetails, getItsMe } from '../utils'
import { DEFAULT_TIMELINE_ITEMS_IDS } from './constants'

export const getFormItem = ({ task, t, locale }: MayAddItemProps) => {
  const person = task?.person as PersonT
  const date = task.insertedAt
    ? formatDate({
        date: task.insertedAt,
        dateFormat: DATE_FORMAT_VARIANTS.shortWithWeekdayAndTime,
        locale,
        t,
      })
    : ''

  const formAttributes = createTimelineItemAttributesWithHrAvatar(
    {
      id: DEFAULT_TIMELINE_ITEMS_IDS.share_user_data,
      title: date,
      status: TIMELINE_STATUS.past,
    },
    t,
  )
  const formContent = { tenantName: person?.tenant?.name ?? '' }

  return createTimeLineItem({ attributes: formAttributes, content: formContent ?? undefined })
}

export const getDocumentItem = ({ task, t, locale }: MayAddItemProps) => {
  const document = task?.taskMonthlySheet?.document as DocumentT | undefined
  const person = task?.person as PersonT
  const date = document?.createdByMirus
    ? formatDate({
        date: document?.createdByMirus,
        dateFormat: DATE_FORMAT_VARIANTS.shortWithWeekdayAndTime,
        locale,
        t,
      })
    : ''

  const documentAttributes = createTimelineItemAttributesWithHrAvatar(
    {
      id: DEFAULT_TIMELINE_ITEMS_IDS.monthly_sheet,
      title: date,
      status: TIMELINE_STATUS.past,
    },
    t,
  )
  const documentContent = { document, tenantName: person?.tenant?.name ?? '' }

  return createTimeLineItem({ attributes: documentAttributes, content: documentContent ?? undefined })
}

export const getAbsenceRequestItem = ({ task, t, locale, personIds = [] }: MayAddItemProps) => {
  const itsMe = getItsMe({ authorId: task.person?.id ?? undefined, myPersonIds: personIds })
  const avatar = getAvatarFromPerson(task?.person as PersonT, t, itsMe)
  const date = task.insertedAt
    ? formatDate({
        date: task?.insertedAt,
        dateFormat: DATE_FORMAT_VARIANTS.shortWithWeekdayAndTime,
        locale,
        t,
      })
    : ''
  const badge = TimelineItemContentBadgeTypeT.absenceRequested

  return createTimeLineItem({
    attributes: {
      id: DEFAULT_TIMELINE_ITEMS_IDS.absence_request,
      title: date,
      avatarData: avatar,
      status: TIMELINE_STATUS.past,
    },
    content: {
      absenceDetails: getAbsenceDetails({
        task,
        t,
        timelineItem: {
          badge,
        },
      }),
      badge,
      text: task?.comment ?? '',
    },
  })
}
